import createPlugin from './createPlugin';
import VideoHtmlRenderer from './Renderer/VideoHtmlRenderer';
var plugin = createPlugin({
    Renderer: VideoHtmlRenderer,
});
export default plugin;
//# sourceMappingURL=index.js.map